import { RentPeriod } from '../enums/RentPeriod';

const rentPeriodMapping: Record<RentPeriod, string> = {
    [RentPeriod.UNKNOWN]: '',
    [RentPeriod.DAY]: 'день',
    [RentPeriod.MONTH]: 'мес.',
    [RentPeriod.YEAR]: 'год'
};

export { rentPeriodMapping };
